import { SettingsLayout } from './settings-layout';
import { OrganizationSettingsPage } from './organization-settings-page';
import { UserManagementPage } from './user-management-page';
import { RolesPermissionsPage } from './roles-permissions-page';
import { IntegrationsPage } from './integrations-page';
import { NotificationsPage } from './notifications-page';
import { BrandThemingPage } from './brand-theming-page';
import { SecurityCompliancePage } from './security-compliance-page';
import { TeamInvitePage } from './team-invite-page';
import { JoinPage } from './join-page';

export const settingsRoutes = [
  {
    path: 'settings',
    element: <SettingsLayout />,
    children: [
      {
        path: 'organization',
        element: <OrganizationSettingsPage />
      },
      {
        path: 'users',
        element: <UserManagementPage />
      },
      {
        path: 'team-invite',
        element: <TeamInvitePage />
      },
      {
        path: 'roles',
        element: <RolesPermissionsPage />
      },
      {
        path: 'integrations',
        element: <IntegrationsPage />
      },
      {
        path: 'notifications',
        element: <NotificationsPage />
      },
      {
        path: 'branding',
        element: <BrandThemingPage />
      },
      {
        path: 'security',
        element: <SecurityCompliancePage />
      }
    ]
  },
  // Public route for handling invitations
  {
    path: 'join',
    element: <JoinPage />
  }
]; 